export const PULSE_API_ENDPOINT = "/api/v1/usage-pulse";
export const PULSE_INTERVAL = 3600000; /* 60 minutes in miliseconds */
export const USER_ACTIVITY_LISTENER_EVENTS = ["pointerdown", "keydown"];
export const FALLBACK_KEY = "APPSMITH_ANONYMOUS_USER_ID";
export const PULSE_API_RETRY_TIMEOUT = 2000; /*2 seconds  in miliseconds*/
export const PULSE_API_MAX_RETRY_COUNT = 3;
